import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const privacy = state.user.privacy;

  if (isEmpty(privacy)) {
    return true;
  }

  if (privacy.search !== undefined) {
    return privacy.search;
  } else {
    return true;
  }
};
//VERIFY IF THE JWT IS SET
const getMySearchVisibilitySetting = createSelector(
  getData,
  privacy => privacy
);
export default getMySearchVisibilitySetting;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMySearchVisibilitySetting.js